// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zHVF","footer":"styles_footer__2zQQa"};